import React, { useState, Fragment } from 'react';
import produce from 'immer';
import TimePicker from 'rc-time-picker';
import { SingleDatePicker } from 'react-dates';
import moment from "moment";
import ValidationError from "~/Components/Forms/ValidationError";
import ToggleSwitch from "~/Components/ToggleSwitch/ToggleSwitch";
import TextTranslate, { TextTranslateString } from '../../../Components/TextTranslate/TextTranslate';
import { connect } from 'react-redux';

function CarRow({ onChange, values, errors, type, ...props }) {

    const dateFocusInitialState = { from: false, to: false };
    const [dateFocused, setDateFocused] = useState(dateFocusInitialState);

    const defaultFields = {
        car_registration_number: '',
        need_parking: false,
        arrival_date: null,
        arrival_time: null,
        departure_date: null,
        departure_time: null,
        comments: ''
    };

    let travelPoints = {
        to: 'Arrival',
        from: 'Departure',
    }

    const form = { ...defaultFields, ...values };

    const inputChanged = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        const newForm = produce(form, (draft) => {
            draft[name] = value;
        });

        onChange(newForm);
    };

    const dateChanged = (value, field) => {
        onChange(produce(form, (draft) => {
            draft[field] = value;
        }));
    };

    const handleSwitch = (field) => {

        onChange(produce(form, (draft) => {
            draft[field] = !draft[field];
        }));
    }

    const timeChanged = (value, key) => {
        onChange(produce(form, (draft) => {
            if (value.isValid()) {
                value.seconds(0);
                draft[key] = moment.utc(value);

            } else {
                draft[key] = null;
            }
        }));
    };

    const dateFocusChanged = (f, key) => {
        setDateFocused({ ...dateFocusInitialState, [key]: f.focused });
    }

    return (
        <div>
            <div>
                <label><TextTranslate name="car-reg-number" fallback="Car Registration #" textOnly /></label>
                <input type="text"
                    value={form.car_registration_number}
                    name="car_registration_number"
                    onChange={inputChanged}
                    className="form-control" />

                <ValidationError errors={errors} name="car.car_registration_number" />
            </div>

            <div className="mt-1">
                <label><TextTranslate name="car-parking-title" fallback="Parking" textOnly /></label>
                <ToggleSwitch
                    label2={TextTranslateString("car-parking-switch", "Will you require parking?", props.currentLanguage, props.translations)}
                    name="need_parking"
                    onChange={() => handleSwitch('need_parking')}
                    isChecked={form.need_parking}
                    id="need_parking"
                />

                <ValidationError errors={errors} name="car.need_parking" />
            </div>

            {Object.keys(travelPoints).map((key, index) => (
                <Fragment key={`travel_${travelPoints[key]}`}>
                    <div className="flex-gap mt-1">
                        <div className="flex-1">
                            <label><TextTranslate name={`car-${travelPoints[key].toLowerCase()}-date`} fallback={`${travelPoints[key]} Date`} textOnly /></label>
                            <div className="d-flex flex-column">
                                <SingleDatePicker
                                    readOnly={true}
                                    isRTL={props.currentLanguage?.rtl}
                                    placeholder={TextTranslateString("placeholder-date", "Date", props.currentLanguage, props.translations)}
                                    id={`${travelPoints[key].toLowerCase()}_date`}
                                    small={true}
                                    focused={dateFocused[travelPoints[key].toLowerCase()]}
                                    date={form[`${travelPoints[key].toLowerCase()}_date`] ? moment(form[`${travelPoints[key].toLowerCase()}_date`]).locale(props.currentLanguage.code) : undefined}
                                    onDateChange={(date) => dateChanged(date, `${travelPoints[key].toLowerCase()}_date`)}
                                    onFocusChange={(f) => dateFocusChanged(f, travelPoints[key].toLowerCase())}
                                    openDirection={'up'}
                                    keepOpenOnDateSelect={false}
                                    hideKeyboardShortcutsPanel={true}
                                    numberOfMonths={1}
                                    monthFormat='MMM YYYY'
                                    displayFormat='ddd DD MMM'
                                    renderMonthElement={({ month }) => moment(month).locale(props.currentLanguage.code).format('MMMM YYYY')}
                                    renderDayContents={(day) => moment(day).locale(props.currentLanguage.code).format('D')}
                                />

                                <ValidationError errors={errors} name={`car.${travelPoints[key].toLowerCase()}_date`} />
                            </div>
                        </div>

                        <div className="flex-1">
                            <label><TextTranslate name={`car-${travelPoints[key].toLowerCase()}-time`} fallback={`${travelPoints[key]} Time`} textOnly /></label>

                            <TimePicker
                                className="d-block"
                                popupClassName="timepicker-neom"
                                onChange={(time) => timeChanged(time, `${travelPoints[key].toLowerCase()}_time`)}
                                defaultValue={form[`${travelPoints[key].toLowerCase()}_time`]}
                                showSecond={false}
                                placeholder={`${travelPoints[key]} Time`}
                            />

                            <ValidationError errors={errors} name={`car.${travelPoints[key].toLowerCase()}_time`} />
                        </div>
                    </div>
                </Fragment>
            ))}

            <div className="mt-3">
                <label className="mb-1"><TextTranslate name="word-comments" fallback="Comments" /></label>
                <small className="d-block mb-2"><TextTranslate name="travel-comments-note" fallback="Please specify any additional details or comments." textOnly /></small>
                <textarea
                    name="comments"
                    onChange={e => {
                        inputChanged(e, 'comments')
                    }}
                    className="form-control" rows="3" defaultValue={form.comments} />

                <ValidationError errors={errors} name="car.comments" />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations,
});

export default connect(mapStateToProps)(CarRow);